import { Product } from '@probatix/common/services/RTKServices/checkoutSteps/checkoutStepsService.model'

export const findProduct = (products: Product[], urlKey: string) => products.find((p) => {
  if ('default' === urlKey) {
    return p.isShowProductOnFrontend
  }

  return p.uuid === urlKey
})
